import { Box } from "@mui/joy";
import TaskHeader from "../header/TaskHeader";
import { useRecoilState, useRecoilValue } from "recoil";
import { paymentOrderAtom } from "recoil/paymentOrderAtom";
import { useQuery } from "@tanstack/react-query";
import {
  PAYMENT_DOMAIN,
  PAYMENT_ORDER_DETAIL_ENDPOINT,
  paymentApi,
} from "api/paymentApi";
import React, { useEffect } from "react";
import { userAtom } from "recoil/userAtom";
import useIsInappWebview from "hooks/useIsInappWebview";
import TransparentHeader from "../header/TransparentHeader";
import { pcSideTabAtom } from "../../../recoil/pcSideTabAtom";
import PaymentContentCarePass from "./PaymentContentCarePass";
import PaymentContentPayback from "./PaymentContentPayback";
import PaymentContentKoreanMania from "./PaymentContentKoreanMania";
import PaymentContentDefault from "./PaymentContentDefault";
import PaymentContentPageTypeC from "./PaymentContentPageTypeC";

export default function Payment() {
  const [paymentOrderState, setPaymentOrderState] =
    useRecoilState(paymentOrderAtom);
  const user = useRecoilValue(userAtom);
  const isInappWebview = useIsInappWebview();
  const pcSideTab = useRecoilValue(pcSideTabAtom);

  const { refetch: getPaymentOrder } = useQuery(
    [PAYMENT_DOMAIN, PAYMENT_ORDER_DETAIL_ENDPOINT],
    () => paymentApi.getOrderDetail(),
    {
      enabled: false,
      onSuccess: (data) => {
        if (data && data.result) {
          setPaymentOrderState(data.result);
        }
      },
    }
  );

  useEffect(() => {
    if (user?.accessToken) {
      getPaymentOrder();
    }
  }, []);

  return (
    <>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 100,
        }}
      >
        {isInappWebview ? (
          <TransparentHeader />
        ) : (
          pcSideTab === "home" && <TaskHeader taskKey={"payment"} />
        )}
      </Box>
      {paymentOrderState && user && (
        <div className="w-full h-full overflow-x-hidden">
          {user.isCarePass === true ? (
            <PaymentContentCarePass />
          ) : user?.paymentPageType === "c" && !paymentOrderState.isFirst ? (
            <PaymentContentDefault />
          ) : user?.paymentPageType === "c" ? (
            <PaymentContentPageTypeC />
          ) : user?.pricingModel === "aeg" && user?.refundPolicyType === "c" ? (
            <PaymentContentDefault />
          ) : user.pricingModel === "aeg" ? (
            <PaymentContentPayback />
          ) : user.pricingModel === "koreanmania" ? (
            <PaymentContentKoreanMania />
          ) : (
            <PaymentContentDefault />
          )}
        </div>
      )}
    </>
  );
}
